export enum BuiltinPlanViewType {
  EMPTY = "EMPTY",
  FLOOR = "FLOOR",
  FOUNDATION = "FOUNDATION",
  ELECTRICAL = "ELECTRICAL",
  ROOF = "ROOF",
  BROCHURE = "BROCHURE",
  UTILITY = "UTILITY",
  STRUCTURAL = "STRUCTURAL",
  FLOOR_MATERIALS = "FLOOR_MATERIALS",
  FLOOR_SUMMARY = "FLOOR_SUMMARY",
  BACKGROUND = "BACKGROUND",
}
